module.exports = __webpack_public_path__ + "img/solana.51aedcba.svg";